<template>
    <div>
        <div class="form-row">
            <div class="form-group col-3">
                <select required v-model.trim="$v.title.$model" class="custom-select" :class="{'is-invalid' : $v.title.$error || errors.title.length}">
                    <option value="" disabled selected hidden >Title</option>
                    <option v-for="(ttl , k) in titles" :key="k">{{ttl}}</option>
                </select>
                <div class="invalid-feedback" v-if="!$v.title.required">
                    Please tell us your title!
                </div>
                <div class="invalid-feedback" v-for="(err, key) in errors.title" :key="key">{{ err }}</div>
            </div>
            <div class="form-group col-5">
                <input v-model.trim="$v.first_name.$model" type="text" class="form-control" :class="{'is-invalid' : $v.first_name.$error || errors.first_name.length}" placeholder="First Name">
                <div class="invalid-feedback" v-if=" !$v.first_name.required">
                    Please enter your first name!
                </div>
                <div class="invalid-feedback" v-for="(err, key) in errors.first_name" :key="key">{{ err }}</div>
            </div>
            <div class="form-group col-4">
                <input v-model.trim="$v.last_name.$model" type="text" class="form-control" :class="{'is-invalid' : $v.last_name.$error || errors.last_name.length}"  placeholder="Last Name">
                <div class="invalid-feedback" v-if=" !$v.last_name.required">
                    Please enter your last name!
                </div>
                <div class="invalid-feedback" v-for="(err, key) in errors.last_name" :key="key">{{ err }}</div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col">
                <input v-model.trim="$v.email.$model" type="email" class="form-control" :class="{'is-invalid' : $v.email.$error || errors.email.length}" placeholder="Email address">
                <div class="invalid-feedback" v-if=" !$v.email.required">
                    Please enter your email!
                </div>
                <div class="invalid-feedback" v-if="!$v.email.email">
                    Please enter a valid email!
                </div>
                <div class="invalid-feedback" v-for="(err, key) in errors.email" :key="key">{{ err }}</div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col">
                <div class="input-group"
                     :class="{'is-invalid' : $v.phone.$error || errors.phone.length }">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="phonecode_addon">+44</span>
                    </div>
                    <input type="text" id="phoneNumber" class="form-control"
                           aria-describedby="phonecode_addon"
                           v-model.trim="$v.phone.$model"
                           placeholder="7911 123456"
                           :class="{'is-invalid' : $v.phone.$error}">
                </div>
        
                <div class="invalid-feedback" v-if="!$v.phone.required">
                    Please enter your phone number!
                </div>
                <div class="invalid-feedback" v-if="!$v.phone.validPhone">
                    Please enter a valid phone number!
                </div>
        
                <div class="invalid-feedback" v-for="(err, key) in errors.phone" :key="key">
                    {{err}}
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col">
                <input v-model.trim="$v.password.$model" type="password" class="form-control" :class="{'is-invalid' : $v.password.$error || errors.password.length}" placeholder="Create password">
                <div class="invalid-feedback" v-if=" !$v.password.required">
                    Please enter a password!
                </div>
                <div class="invalid-feedback" v-if=" !$v.password.minLength">
                    Password should be at least 6 characters!
                </div>
                <div class="invalid-feedback" v-for="(err, key) in errors.password" :key="key">{{ err }}</div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col">
                <input v-model.trim="$v.confirmPassword.$model" type="password" class="form-control" :class="{'is-invalid' : $v.confirmPassword.$error}" placeholder="Confirm password">
                <div class="invalid-feedback" v-if="!$v.confirmPassword.sameAsPassword">
                    Please enter the same password!
                </div>
            </div>
        </div>
        
        <div class="form-row" v-if="!storedReferralCode">
            <div class="form-group col">
                <hr class="mt-0">
                <input v-model.trim="referralCode" type="text" class="form-control"  placeholder="Referral code">
                <hr class="mb-0">
            </div>
        </div>
        <p class="text-center">By registering with MySwitchPro you agree to our <router-link to="/privacy">Privacy Policy</router-link></p>
        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="marketing_consent" v-model="marketing_consent">
            <label class="form-check-label" for="marketing_consent">
                I agree to MySwitchPro.com keeping me informed with personalised news and offers, it believes would interest me
            </label>
        </div>
        <hr>
        <div class="row">
            <div class=" col">
                <button class="btn btn-success btn-success-gradient btn-lg btn-block"
                        :class="{'is-invalid' : errors.registration.length }" @click="submit" :disabled="running">
                    <div class="spinner-border spinner-border-sm" v-if="running"></div>
                    <span v-else>Show me my Deals and Savings</span>
                </button>
                <div v-for="(err, key) in errors.registration" :key="key" class="invalid-feedback text-center pt-2">{{ err }}</div>
            </div>
        </div>
        <striketrough>
            or
        </striketrough>
        <social-buttons  class="mb-4" :disabled="running" @auth="onSocialAuth" />
        <striketrough>
            Already have an account?
        </striketrough>
        <div class="row">
            <div class=" col">
                <button class="btn btn-info btn-info-gradient btn-lg btn-block" @click="$refs.loginModal.show()" :disabled="running">
                    Login
                </button>
            </div>
        </div>
        <login-modal ref="loginModal"/>
    </div>
</template>

<script>
import Striketrough from "@/components/support/Striketrough";
import SocialButtons from "@/components/auth/SocialButtons";

import {validationMixin} from 'vuelidate';
import {email, minLength, required, sameAs} from 'vuelidate/lib/validators';
import api from "@/utils/api";
import {EventBus, events} from "@/utils/event-bus";
import LoginModal from "@/components/auth/LoginModal";
const PhoneNumber = require('awesome-phonenumber');

const validPhone = (value) => {
    if (!value) {
        return false;
    }
    let pn = PhoneNumber(`+44${value}`, 'GB')
    return pn.isValid();
}

const titles =[
        'Mr','Mrs','Ms','Miss'
    ]
    export default {
        name: "RegistrationForm",
        mixins: [validationMixin],
        components: {LoginModal, SocialButtons, Striketrough},
        data: function () {
            return {
                titles: titles,
                running: false,
                title: '',
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                password: '',
                confirmPassword: '',
                marketing_consent: false,
                referralCode: null,
                errors: {
                    first_name: [],
                    last_name: [],
                    email: [],
                    phone: [],
                    password: [],
                    accepted: [],
                    registration: [],
                    title: [],
                }
            }
        },
        validations: {
            title: {
                required
            },
            first_name: {
                required
            },
            last_name: {
                required
            },
            email: {
                required,
                email
            },
            phone: {
                required,
                validPhone
            },
            password: {
                required,
                minLength: minLength(6)
            },
            confirmPassword: {
                sameAsPassword: sameAs('password')
            },
        },
        computed: {
            storedReferralCode() {
                return this.$store.getters['referral/code'];
            }
        },
        methods: {
            onSocialAuth: function(token) {
                let that = this;
                this.running = true;

                that.errors = Object.fromEntries(Object.entries(this.errors).map(v => [v[0], []]));

                if(this.$store.getters['auth/recommendationCode']){
                    token = {
                        ...token,
                        recommendation_code: this.$store.getters['auth/recommendationCode']
                    }
                }
                
                token['marketing_consent'] = this.marketing_consent;
                
                api.socialauth(token).then(response => {
                    let access = response.data.data;
                    that.authSuccess(access);
                }).catch(() => {
                    that.errors.registration = ["Problem with social authentication"];
                    this.running = false
                })
            },
            authSuccess: function (accessReponse) {
                let that = this;

                api.token = accessReponse.access_token;

                api.profile().then(response => {
                    that.$store.commit('auth/setAccessToken', accessReponse.access_token);
                    that.$store.commit('auth/setAccessTokenExpiresAt', accessReponse.expires_at);
                    that.$store.commit('auth/setUser', response.data.data);
                    EventBus.$emit(events.auth.signup);
                    if(that.$store.getters['auth/isVerified']){
                        that.$router.push({name: 'SetupDeal'});
                    } else {
                        that.$router.push({name: 'RegisterDone'});
                    }
                }).finally(() => that.running = false);
            },
            submit: function () {
                let that = this;
                that.errors = Object.fromEntries(Object.entries(this.errors).map(v => [v[0], []]));

                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                that.running = true;
                let data = Object.fromEntries(Object.entries(this.$data).filter((value => {
                    return ['confirmPassword','running', 'errors'].indexOf(value[0]) < 0;
                })));
                if(this.$store.getters['auth/recommendationCode']){
                    data = {
                        ...data,
                        recommendation_code: this.$store.getters['auth/recommendationCode']
                    }
                }
                
                if(this.$store.getters['referral/code'] || this.referralCode){
                    data = {
                        ...data,
                        referral_code: this.$store.getters['referral/code'] || this.referralCode
                    }
                }
    
                data['phone'] =  this.phone ? !this.phone.startsWith("+44") ? `+44${this.phone}` : this.phone : null;
                data['marketing_consent'] = this.marketing_consent;
                
                api.signup(data).then(response => {
                    let access = response.data.data;
                    that.authSuccess(access);
                }).catch((error) => {
                    if (error.response.status === 400 && error.response.data.error.code === 11111) {
                        that.errors.first_name = error.response.data.meta.first_name;
                        that.errors.last_name = error.response.data.meta.last_name;
                        that.errors.accepted = error.response.data.meta.accepted;
                        that.errors.email = error.response.data.meta.email;
                        that.errors.password = error.response.data.meta.password;
                    } else if(error.response.data.error.code === 11000) {
                        that.errors.registration = ["User already exists!"];
                    }else {
                        that.errors.registration = ["Problem with registration process"];
                    }
                    that.running = false;
                })

            }
        }
    }
</script>

<style scoped>
.custom-select:invalid { color: gray; }
</style>
